module.exports = __webpack_public_path__ + "static/guia-de-marca-2a7cabeae4b86fed300324f9f2fa132a.jpg";